define('lq/events/actions/executeEidReader',[
    'jquery',
    'underscore', 
    'lq/events/actions/eventAction', 
    'lq/util', 
    'jquery.jsonp.min'],
function ($, _, EventAction, util) {
    'use strict';

    var EidServiceUrl = 'http://localhost:31031/eid';

    function ExecuteEidReader(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ExecuteEidReader);

    ExecuteEidReader.typeName = 'ExecuteEidReader';

    ExecuteEidReader.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ExecuteEidReader.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;
        
        $.jsonp({
            url: EidServiceUrl,
            callbackParameter: 'callback',
            cache: false,
            timeout: 30000,
            success: function (data) {
                self.piping.busyIndicator.hide();
                try {
                    if (data.error) {
                        alert("eID-Reader error: " + data.error);
                    } else {
                        self.executeMappings(data, self.eventData.eidMappings);
                    }
                } finally {
                    continuation();
                }
            },
            error: function () {
                self.piping.busyIndicator.hide();
                alert("Could not connect to eID-Reader service, please check if it is running.");
                continuation();
            }
        });

        this.piping.busyIndicator.show();
    };

    var monthMap = [
        { expr: /JAN/, value: "01" },
        { expr: /FE(B|V)/, value: "02" },
        { expr: /MAAR|MARS|M.R/, value: "03" }, // impossible to tell what the umlaut will be encoded like
        { expr: /A(P|V)R/, value: "04" },
        { expr: /M(E|A)I/, value: "05" },
        { expr: /JUI?N/, value: "06" },
        { expr: /JUI?L/, value: "07" },
        { expr: /AUG|AOUT/, value: "08" },
        { expr: /SEPT?/, value: "09" },
        { expr: /O(K|C)T/, value: "10" },
        { expr: /NOV/, value: "11" },
        { expr: /DE(C|Z)/, value: "12" }
    ];

    var birthDateExpression = /(\d\d)\.?\s*(\S+)\.?\s*(\d{4})/;

    var valueConvertersByPath = {
        'id.date_of_birth': function (original) {
            var match = original.match(birthDateExpression);
            if (match) {
                var monthName = match[2];
                var monthEntry = _.find(monthMap, function (entry) { return entry.expr.test(monthName); });
                if (monthEntry)
                    return match[3] + '-' + monthEntry.value + '-' + match[1] + 'T00:00:00';
            }
            return null;
        },
        'id.gender': function (original) {
            if (original === "V" || original === "W")
                return "F";
            return original;
        }
    };

    ExecuteEidReader.prototype.executeMappings = function (data, eidMappings) {
        var self = this;
        _.each(eidMappings, function (mapping) {
            var value = util.getPropertyByPath(data, mapping.sourcePath);
            if (valueConvertersByPath[mapping.sourcePath])
                value = valueConvertersByPath[mapping.sourcePath](value);
            self.piping.parameters.locals.setValue(mapping.targetParameter, value);
        });
        
    };

    return ExecuteEidReader;
});
